import React, { FC } from 'react';
import { SectionWrapper } from '../SectionWraper';
// import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
// import { downloadTxtFile } from '../../utils/components/download-txt';
import { useMerchants } from '../../store/merchnts/merchants-context';

export const BusinessSettingsTermsAndConditions: FC = () => {
	const { merchantState: { merchantData }} = useMerchants();
	return (
		<SectionWrapper
			title="Special Terms and Conditions"
			sectionAdditionalClass="mb-5"
			isCardBody
		>
			{merchantData?.specialTerms ? merchantData.specialTerms : '-'}

			{/*<ButtonComponent*/}
			{/*	buttonType={BUTTON_TYPE.WHITE}*/}
			{/*	buttonName="Download"*/}
			{/*	additionalClass="mt-5"*/}
			{/*	onButtonClick={(): void => downloadTxtFile(MOCK_VALUE, 'TermsAndConditions')}*/}
			{/*/>*/}

		</SectionWrapper>
	);
};
